module.exports = __webpack_public_path__ + "static/media/02.e692cf13.jpg";